module.exports = __webpack_public_path__ + "img/desk4.81d36ad7.png";